import { memo, useState } from 'react';
import { Handle, Position } from 'reactflow';
import { FileText, Edit3, Eye } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import EntityNodeToolbar from './EntityNodeToolbar';

const TextNode = ({ data, selected, id }) => {
  const [isHovered, setIsHovered] = useState(false);
  const content = data.content || '**Double-click to edit**\n\nAdd notes, documentation, or comments using Markdown!';
  const backgroundColor = data.backgroundColor || '#FEF9C3'; // Light yellow default
  const width = data.width || 300;

  return (
    <>
    <EntityNodeToolbar id={id} selected={selected} />
    <div
      className="text-node transition-all duration-200"
      style={{
        minWidth: `${width}px`,
        maxWidth: '600px',
        border: selected ? '2px solid #3B82F6' : '2px solid #E5E7EB',
        borderRadius: '8px',
        backgroundColor: backgroundColor,
        boxShadow: selected
          ? '0 4px 12px rgba(59, 130, 246, 0.3)'
          : '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Header */}
      <div
        className="flex items-center justify-between px-3 py-2 border-b"
        style={{
          backgroundColor: selected ? '#DBEAFE' : '#F9FAFB',
          borderBottomColor: '#E5E7EB',
        }}
      >
        <div className="flex items-center gap-2">
          <FileText size={16} className="text-gray-600" />
          <span className="text-sm font-semibold text-gray-700">
            {data.name || 'Note'}
          </span>
        </div>
        
        {isHovered && (
          <div className="flex items-center gap-1 text-xs text-gray-500">
            <Eye size={12} />
            <span>Preview Mode</span>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-4">
        <div className="prose prose-sm max-w-none text-gray-800">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {content}
          </ReactMarkdown>
        </div>
      </div>

      {/* Hint */}
      {isHovered && (
        <div className="px-3 py-2 text-xs text-gray-500 border-t border-gray-200 bg-gray-50/50">
          💡 Click to select, then edit in Properties panel
        </div>
      )}

      {/* No handles for text nodes - they're just annotations */}
    </div>
    </>
  );
};

export default memo(TextNode);
